export type BrowserName = 'chrome' | 'edge' | 'yandex' | 'comet' | 'firefox' | 'safari';

export const BROWSER_COLORS: Record<BrowserName, string> = {
  chrome: 'var(--br-chrome)',
  edge: 'var(--br-edge)',
  yandex: 'var(--br-yandex)',
  comet: 'var(--br-comet)',
  firefox: 'var(--br-firefox)',
  safari: 'var(--br-safari)',
};

export interface BrowserBadgeProps {
  browser?: BrowserName;
  /** override the text, e.g. "CHROME · KEEP" */
  label?: string;
  /** dashed border = the copy slated to close */
  dashed?: boolean;
  size?: 'sm' | 'md';
}

interface BadgeSize {
  fs: number;
  dot: number;
  pad: string;
  r: number;
}

export function BrowserBadge({ browser = 'chrome', label, dashed = false, size = 'md' }: BrowserBadgeProps) {
  const s: BadgeSize =
    size === 'sm'
      ? { fs: 9, dot: 5, pad: '2px 6px', r: 5 }
      : { fs: 10.5, dot: 6, pad: '5px 11px', r: 999 };
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontFamily: 'var(--font-mono)',
        fontSize: s.fs,
        letterSpacing: '.06em',
        textTransform: 'uppercase',
        color: dashed ? 'var(--text-3)' : 'var(--text-2)',
        border: dashed ? '1px dashed var(--line-strong)' : '1px solid var(--line-strong)',
        borderRadius: s.r,
        padding: s.pad,
        whiteSpace: 'nowrap',
      }}
    >
      <i style={{ width: s.dot, height: s.dot, borderRadius: '50%', background: BROWSER_COLORS[browser] }} />
      {label || browser}
    </span>
  );
}
